import { usePut } from '../../HttpClient';
import { AccountTreatmentIndicatorModel } from '@app/models';
import { tenantHierarchyBaseUrl } from '../BaseUrls';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useUpdateAccountTreatmentIndicator() {
  const put = usePut(true, "tms");
  const updateAccountTreatmentIndicator = (id: string, request: AccountTreatmentIndicatorModel) =>
    put<{ id: string }>(`${tenantHierarchyBaseUrl}/account-treatment-indicators/${id}`, request);

  return useMutationWithErrorHandling({
    mutationFn: async ({ id, request }: { id: string; request: AccountTreatmentIndicatorModel }) =>
      await updateAccountTreatmentIndicator(id, request),
  });
}
